<!--
    The <ng-container? here displays a FormInstance created by a Form Template Instance Component.
    When it's displaying the rest of the home page is hidden

    (Would it be better instead to open the new form in large dialog the covers the screen?)
-->
<ng-container *ngIf="NewFormInstance">
    <app-entity-name-editor [entity]="this.NewFormInstance"
                            [entityType]="'FormInstance'"
                            [maxLength]="256"
                            [renameService]="this.FormInstanceService"
                            (done)="handleNameChange($event)">
    </app-entity-name-editor>

    <app-form-filler #formFiller
                     [formInstance]="this.NewFormInstance"
                     [isClosable]="true"
                     (close)="this.closeNewFormInstance($event)">
    </app-form-filler>
</ng-container>

<div class="home-page-action-buttons-div">
    <div *ngIf="!NewFormInstance && editButtonIsViewable()">
        <button mat-raised-button color="primary" class="edit-home-page-btn" (click)="this.editHomePageClicked()">{{EditHomePageCaption}}</button>
    </div>
    <div>
        <button *ngIf="HomePageForm?.showPublishFolderButton" mat-raised-button color="primary" class="edit-home-page-btn" (click)="this.publishFolderClicked()">Publish Folder</button>
    </div>
    <div>
        <button *ngIf="HomePageForm?.showSubscribeToFolderButton" mat-raised-button color="primary" class="subscribe-to-folder-btn" (click)="this.subscribeToFolderClicked()">Subscribe to a Folder</button>
    </div>
</div>

<app-form-renderer *ngIf="this.HomePageForm && !NewFormInstance"
                   [form]="this.HomePageForm"
                   [formInstance]="this.HomePageDummyFormInstance"
                   [mode]="'instance'"
                   (newObjectCreated)="this.displayNewFormInstance($event)">
</app-form-renderer>
